import React, {useState} from 'react';
import {useDialog} from '../../../hooks';
import {PostponeOfferDialogUpdate} from './PostponeOfferDialogUpdate';
import {PostponeOfferDialogSuccess} from './PostponeOfferDialogSuccess';
import {BaseDialog, KeyRouter} from '@resurs-internal/mui';

// gekås campaign offer
export type PostponeOfferDialogRoutes = 'update' | 'success' | 'close';
export const PostponeOfferDialog: React.FC = () => {
  const {open, onClose} = useDialog('postpone-offer');
  const [routeKey, setRouteKey] = useState('update');
  const navigate = (key: PostponeOfferDialogRoutes) => {
    if (key === 'close') {
      onClose();
      setRouteKey('update');
      return;
    }
    setRouteKey(key);
  };

  return (
    <BaseDialog open={open} onClose={onClose}>
      <KeyRouter
        current={routeKey}
        routes={{
          update: <PostponeOfferDialogUpdate navigate={navigate} />,
          success: <PostponeOfferDialogSuccess navigate={navigate} />,
        }}
      />
    </BaseDialog>
  );
};
